module.exports = __webpack_public_path__ + "static/media/antenna-setup.70692ea5.png";